<template>
  <a-modal
    :title="modalTit"
    :visible="isLimitDialogShow"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    class="set-option-dialog"
    :mask-closable="false"
    :width="`570px`"
    :confirm-loading="confirmLoading"
    :destroy-on-close="true"
    @ok="formHandle"
    @cancel="cancelHandle"
  >
    <div
      v-if="itemData.fieldtype === 'select'"
      class="tip-info-tip"
      :class="{ 'tip-info-tip-english': $isEnglish}"
    >
      {{ $t('message["1778"]') }}
    </div>
    <div class="input-form set-option-form">
      <a-form
        :form="form"
        layout="inline"
      >
        <draggable
          v-model="itemData.options"
          @end="dragEndHandle"
        >
          <div
            v-for="(item, index) in child"
            :key="item.id || item._id"
            class="input-row"
          >
            <set-option-item
              :item-data="itemData"
              :item="item"
              :index="index"
            />
          </div>
        </draggable>
        <a-form-item>
          <a-button
            class="add-option-btn"
            @click="addDefine"
          >
            <i
              class="icon iconfont iconicon-test10"
            />
            {{ $t('message["1561"]') }}
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import SetOptionItem from './SetOptionItem'
import { mapState } from 'vuex'
export default {
  components: {
    SetOptionItem
  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    },
    cloneData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false
    }
  },
  provide () {
    return {
      diaform: this
    }
  },
  computed: {
    ...mapState('config/collect', ['datas']),
    child () {
      // const { child = [] } = this.itemData.options
      return this.itemData.options
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    },
    modalTit () {
      return this.$t('message["1037"]')
    }
  },
  mounted () {
  },
  created () {
    this.form = this.$form.createForm(this)
    // this.form.getFieldDecorator('name', { initialValue: [], preserve: false })
  },
  methods: {
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    addDefine () {
      this.itemData.options.push({
        _id: (Math.random() * 10000000).toString(16).substr(0, 4) + '-' + (new Date()).getTime(),
        issystem: 0,
        isdefault: 0,
        name: ''
      })
    },
    formHandle () {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.itemData.options.forEach(item => {
            if (item._id) {
              delete item._id
            }
          })
          this.isLimitDialogShow = false
          this.$emit('getHiddenVal', this.itemData.options.join(','))
        }
      })
    },
    isEndChange (e) {
      // console.log(e)
    },
    dragEndHandle ({ oldIndex, newIndex }) {
    },
    dragUpate (dd) {
      const nameDatas = this.form.getFieldValue('name')
      nameDatas.forEach((name, index) => {
        this.itemData.options[index].name = name
      })
    },
    changeVal (item, index, e) {
      // item.name = this.form.getFieldValue('name')[index]
    },
    cancelHandle () {
      this.isLimitDialogShow = false
      this.$set(this.itemData, 'options', this.cloneData.options)
    }
  }
}
</script>

<style lang="scss" scoped>
  .input-form::v-deep {
    margin:11px 20px;

    .ant-input {
      width: 320px;
    }
    .add-option-btn {
      margin: 10px 32px;
      .iconicon-test10 {
        color: #ccc;
        font-size: 16px;
        margin-right: 6px;
      }
    }
  }
  .tip-info-tip {
      // position: absolute;
      height: 40px;
      line-height: 40px;
      background: #fff4e7;
      padding: 0 30px;
      color: #f6a953;
      left: 0;
      top: 55px;

    }
    .tip-info-tip-english {
      line-height: 22px;
      height: auto;
      padding: 8px 30px
    }
     .set-option-form {
      max-height: 292px;
      overflow-y: auto;
    }
</style>
